import React from 'react'

const GreatValueIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <path
        d='M14.28 3.708a1.196 1.196 0 0 0-1.271.244L11.5 5.405 8.825 2.829a1.199 1.199 0 0 0-1.65 0L4.5 5.405 2.991 3.952a1.2 1.2 0 0 0-1.27-.243C1.283 3.883 1 4.292 1 4.746v5.946c.002 1.55 1.307 2.806 2.917 2.808h8.166c1.61-.002 2.915-1.258 2.917-2.808V4.746c0-.454-.284-.864-.72-1.038z'
        fill='#673099'
        fillRule='nonzero'
      />
    </svg>
  )
}

export default GreatValueIcon
